import { render, staticRenderFns } from "./WelcomeTitleAdvanced.vue?vue&type=template&id=0a66cbc5&"
import script from "./WelcomeTitleAdvanced.vue?vue&type=script&lang=js&"
export * from "./WelcomeTitleAdvanced.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeTitleAdvanced.vue?vue&type=style&index=0&id=0a66cbc5&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports